module.exports = __webpack_public_path__ + "media/images/menu_izq/administrativo-0e6fe88f49ca678acd835821afcaf654.svg";